// @flow
import { createSelector } from 'reselect';

export const locationsSelector = createSelector(
  state => state.locations,
  locations => locations
);

export const locationsListSelector = createSelector(
  locationsSelector,
  locations => Object.keys(locations)
);
